import httpClient from "api/httpClient";

const getAnyCoins = (params?: Record<string, any>) =>
  httpClient.get(`admin/anycoin/stats`, { params });

export default { getAnyCoins };
